(function () {
    document.addEventListener('DOMContentLoaded', function () {

        let stickyISI = document.querySelector('#sticky-isi');
        let staticISI = document.querySelector('#static-isi');
        let allOfTheAccordions = document.querySelectorAll('.accordion1, .accordion2');
        let closeBtn = document.querySelectorAll('.close-btn');
        let closeAccordions = document.querySelectorAll('.close-accordion');
        const ACTIVATED_COOKIE_NAME = 'sticky_isi_activated';

        // current window scroll position
        let startPosition = 0;
        
        setTimeout(() => (startPosition = window.pageYOffset || document.documentElement.scrollTop), 600);

        function setCookie(name, value, days) {
            const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
            document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
        }

        function getCookie(name) {
            const cookie = document.cookie
                .split('; ')
                .find(row => row.startsWith(name + '='));

            return cookie ? decodeURIComponent(cookie.split('=')[1]) : null;
        }

        function syncActivatedCookie() {
            const isActivated = stickyISI.classList.contains('activated') ? '1' : '0';
            setCookie(ACTIVATED_COOKIE_NAME, isActivated, 30);
        }

        if (getCookie(ACTIVATED_COOKIE_NAME) === '1') {
            stickyISI.classList.add('activated');
        }

        // Close is clicked, toggle the isi
        closeBtn.forEach(el => el.addEventListener('click', toggleISI));
        closeAccordions.forEach(el => el.addEventListener('click', toggleAccordion));

        function toggleISI() {
            let pageBody = document.querySelector('body');
            // State transitions
            // close->open
            if (stickyISI.classList.contains('close')) {
                stickyISI.classList.remove('activated');
                stickyISI.classList.remove('close');
                stickyISI.classList.add('open');
                syncActivatedCookie();

                // stop other content from scrolling
                pageBody.classList.add('overflow-hidden');
                pageBody.classList.remove('overflow-scroll');
            }

            // open->close
            else if (stickyISI.classList.contains('open')) {
                stickyISI.classList.remove('open');
                stickyISI.classList.add('activated');
                stickyISI.classList.add('close');
                syncActivatedCookie();

                // Toggle scroll state
                pageBody.classList.remove('overflow-hidden');
                pageBody.classList.add('overflow-scroll');
            }
        }

        function isAnyAccordionOpen() {
            let accordionStateOpen;

            for (let i=0; i<closeAccordions.length; i++) {
                if (closeAccordions[i].classList.contains('expanded')) {
                    accordionStateOpen = true;
                    return accordionStateOpen;
                }
            }
        }

        function toggleAccordion() {
            let theAccordion = this.classList;
            let pageBody = document.querySelector('body');

            if (theAccordion.contains('collapsed')) {
                for (let i=0; i<allOfTheAccordions.length; i++) {
                    allOfTheAccordions[i].classList.remove('collapsed');
                    allOfTheAccordions[i].classList.add('expanded');
                    closeAccordions[i].classList.remove('collapsed');
                    closeAccordions[i].classList.add('expanded');
                }
                theAccordion.remove('collapsed');
                theAccordion.add('expanded');
            } else if (theAccordion.contains('expanded')) {
                for (let i=0; i<allOfTheAccordions.length; i++) {
                    allOfTheAccordions[i].classList.remove('expanded');
                    allOfTheAccordions[i].classList.add('collapsed');
                    closeAccordions[i].classList.remove('expanded');
                    closeAccordions[i].classList.add('collapsed');
                }
                theAccordion.remove('expanded');
                theAccordion.add('collapsed');
            }

            if (isAnyAccordionOpen()) {
                stickyISI.classList.remove('activated');
                stickyISI.classList.remove('close');
                stickyISI.classList.add('open');
                pageBody.classList.add('overflow-hidden');
                pageBody.classList.remove('overflow-scroll');
                syncActivatedCookie();
            } else {
                stickyISI.classList.remove('open');
                stickyISI.classList.add('activated');
                stickyISI.classList.add('close');
                pageBody.classList.remove('overflow-hidden');
                pageBody.classList.add('overflow-scroll');
                syncActivatedCookie();
            }
        }

        //hides sticky ISI on load on smaller content pages
        let position = staticISI.getBoundingClientRect();

        if (position.top < window.innerHeight && position.bottom >= 0) {
            stickyISI.classList.add('d-none');
        }

        window.addEventListener('scroll', function() {
            let position = staticISI.getBoundingClientRect();

            console.log('scroll', position.top, position.bottom, window.innerHeight);

            // checking for visibility
            // if (position.top < window.innerHeight && position.bottom >= 0) {
            if (position.top < window.innerHeight || position.bottom < 0) {
                stickyISI.classList.add('d-none');
            } else {
                stickyISI.classList.remove('d-none');
            }
        });

    });
})();

(function ($) {
    $(function () {

        var $bTT = $('.back-to-top');
        var $header = document.querySelector('.header');

        $(window).on('scroll', function () {
            if ($(this).scrollTop() > 600) {
                $bTT.addClass('visible');
            } else {
                $bTT.removeClass('visible');
            }
        });

        $bTT.on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({scrollTop: 0}, '300');
            $header.classList.remove('collapsed');
        });

    });
})(jQuery);
